<template>
  <div>
    <breadcrumb :crumbs="crumbs"></breadcrumb>
    <flash-message></flash-message>
    <form data-vv-scope="form-1">
      <div class="col-md-5">
        <h3 class="ls-title-4">{{ $t('settings.main.integration') }}</h3>
        <p>{{ $t('settings.label.select_payment_method') }}</p>
      </div>
      <div class="col-md-7">
        <label class="ls-label">
          <b class="ls-label-text">{{ $t('settings.attributes.type') }}</b>
          <div class="ls-custom-select">
            <select class="ls-select" :name="$t('settings.attributes.select_acquirer')" v-model="selectedType" @change="loadPaymentMethods" v-validate="'required'">
              <option value="" selected="selected"> {{ $t('settings.label.choose_option') }} </option>
              <option :value="type" :id="type" v-for="type in types"> {{ parseType(type) }} </option>
            </select>
          </div>
        </label>
        <div v-if="errorMessage" class="ls-alert-warning"><strong>Atenção!</strong> {{ errorMessage }}</div>
        <div v-if="paymentMethods.length" class="ls-box" style="overflow-y: auto; height: 50vh;">
          <table class="ls-table">
            <tbody>
              <tr>
                <td><strong>{{ $t('settings.main.all_methods') }}</strong></td>
                <td>
                  <a href="javascript:void(0)" class="ls-btn ls-float-right" @click="toggleSwitches(true)">{{ $t('settings.label.buttons.check_all') }}</a>
                  <a href="javascript:void(0)" class="ls-btn-danger ls-float-right ls-sm-margin-left" @click="toggleSwitches(false)">{{ $t('settings.label.buttons.uncheck_all') }}</a>
                </td>
              </tr>
              <tr v-for="paymentMethod, index in paymentMethods">
                <td>
                  <img class="ls-float-left ls-md-margin-right" :src="paymentMethod.logo" alt="logo cartão" width="35">{{ paymentMethod.description }}
                </td>
                <td>
                  <button-switch :reference="paymentMethod.name" @toggle="toggleCheckbox" class="ls-float-right"></button-switch>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-if="paymentMethods.length">
        <div class="ls-clearfix"></div>
        <div class="ls-lg-margin-top">
          <div class="col-md-5" >
            <h3 class="ls-title-4">{{ $t('settings.main.integration_data') }}</h3>
            <p>{{ $t('settings.label.enter_data_from_acquirer_to_setup_payment_method') }}</p>
          </div>
          <div class="col-md-7">
            <div v-for="customField in customFields">
              <label class="ls-label">
                <b class="ls-label-text">{{ customField.name }}</b>
                <input type="text" :name="customField.tag" v-model="customField.value">
              </label>
            </div>
          </div>
          <div class="ls-clearfix"></div>
        </div>
      </div>
        <div class="ls-actions-btn col-md-12">
          <div class="ls-float-right">
            <router-link :to='"/settings/payment_settings/" + processor + "/show"'class="ls-btn" :title="$t('application.menu.payment_settings')">{{ $t('application.button.back') }}</router-link>
            <button v-if="paymentMethods.length" :class="buttonSave()" @click.prevent="saveSettings()">{{ $t('application.button.save') }}</button>
          </div>
        </div>
    </form>
  </div>
</template>
<script>
  import { mapMutations, mapGetters, mapActions } from 'vuex'
  import Popover from 'src/app/components/shareds/popover/Popover'
  import date from 'src/utils/date'
  import Breadcrumb from 'src/app/components/shareds/Breadcrumb'
  import ButtonSwitch from 'src/app/components/shareds/ButtonSwitch'
  import * as test from 'src/utils/gateway_payment_method'

  export default {
    name: 'new-payment-method',
    components: { Popover, Breadcrumb, ButtonSwitch },
    props: [],
    data () {
      return {
        date: date,
        showMessage: false,
        showSuccess: false,
        selected: [],
        types: [],
        paymentMethod: '',
        checkPaymentMethods: [],
        errorMessage: '',
        processor: '',
        selectedType: '',
        crumbs: {
          'ico': 'ls-ico-cog',
          'section': this.$t('settings.main.include_payment_method'),
          'paths': {
            0: {
              'title': this.$t('settings.main.select_payment_method'),
              'path': '/settings/payment_settings'
            },
            1: {
              'title': this.$t('settings.main.payment_acquirer'),
              'path': '/settings/payment_settings/index'
            },
            2: {
              'title': this.$t('settings.main.payment_methods'),
              'path': '/settings/payment_settings/' + this.$route.params.processor + '/show'
            }
          }
        }
      }
    },
    methods: {
      ...mapMutations(['setPaymentMethods', 'clearPaymentMethods', 'clearFlash']),
      ...mapActions(['loadNewPaymentMethods', 'loadCustomFields', 'updatePaymentMethods']),
      loadPaymentMethods () {
        this.checkPaymentMethods = []
        this.clearPaymentMethods()
        this.$loader.show()
        this.errorMessage = ''
        if (!this.selectedType) {
          this.$loader.hide()
          return
        }
        this.clearFlash()
        this.loadNewPaymentMethods({ type: this.selectedType, processor: this.processor }).then(this.loadFields)
      },
      parseType (type) {
        switch (type) {
          case 'c': return 'Crédito'
          case 'b': return 'Boleto'
        }
      },
      buttonSave () {
        if (this.checkPaymentMethods.length) {
          return 'ls-btn-primary'
        }
        return 'ls-btn-primary ls-disabled'
      },
      saveSettings () {
        this.$loader.show()
        let params = { tags: [], methods: this.checkPaymentMethods, processor: this.processor }
        for (var i = 0; i < this.customFields.length; i++) {
          params.tags[i] = { tag: this.customFields[i].tag, value: this.customFields[i].value }
        }
        this.updatePaymentMethods(params).then(this.goToRedirect)
      },
      goToRedirect () {
        if (this.paymentMethods.length > 1) {
          this.$loader.hide()
          window.scrollTo(0, 0)
          this.selectedType = ''
          this.loadPaymentMethods()
          return
        }
        this.$router.push('/settings/payment_settings/' + this.processor + '/show')
      },
      loadFields () {
        if (!this.paymentMethods.length) {
          this.$loader.hide()
          this.errorMessage = 'Nenhuma forma disponivel'
          return
        }
        this.mountCheckMethods()
        this.loadCustomFields({ processor: this.processor, paymentMethod: this.paymentMethods[0].name }).then(this.$loader.hide)
      },
      mountCheckMethods () {
        for (var i = 0; i < this.paymentMethods.length; i++) {
          this.paymentMethods[i].checked = false
        }
      },
      toggleCheckbox (name) {
        var index = this.checkPaymentMethods.indexOf(name)
        if (index >= 0) {
          this.checkPaymentMethods.splice(index, 1)
        } else {
          this.checkPaymentMethods.push(name)
        }
      },
      toggleSwitches (value) {
        if (value) {
          this.checkPaymentMethods = this.paymentMethods.map(function (item) {
            return item.name
          })
        } else {
          this.checkPaymentMethods = []
        }
        this.$helper.$emit('toggleSwitches', value)
      }
    },
    mounted () {
      this.processor = this.$route.params.processor
      this.types = test.billetOrCard(this.processor)
      this.clearPaymentMethods()
    },
    computed: {
      ...mapGetters(['paymentMethods', 'customFields'])
    }
  }
</script>



// WEBPACK FOOTER //
// NewPaymentSettings.vue?07408d77